module.exports = __webpack_public_path__ + "img/slide1.e27320f4.jpg";